<template>
  <div class="packageDesc">
    <div class="confim-box">
      <!-- 购买服务顶部 开始 -->
      <div class="packageDesc_top">
        <img class="packageDesc_img" :src="serviceList.product ? serviceList.product.thumb : ''" />
        <div class="text">{{serviceList.name}}</div>
      </div>
      <!-- 购买服务顶部 结束 -->
      <!-- 商品信息 开始 -->
      <div class="packageDesc_shangpinmesg">
        <div class="beCareful-titlebox">
          <div class="beCareful-icon"></div>
          <div class="beCareful-title">商品信息</div>
        </div>
        <div class="packageDesc_shangpin_box">
          <div class="icon-text">原价</div>
          <div class="packageDesc_shangpin_mesgvalue icon-text">￥{{serviceList.m_price}}</div>
        </div>
        <div class="packageDesc_shangpin_box">
          <div class="icon-text">售价</div>
          <div class="icon-text text-tipcolor">￥{{serviceList.price}}</div>
        </div>
        <div class="packageDesc_shangpin_box">
          <div class="icon-text">车主卡优惠价</div>
          <div class="icon-text text-tipcolor">￥{{serviceList.ccard_price}}</div>
        </div>
        <div class="packageDesc_shangpin_box" v-if="phoneNum">
          <div class="icon-text">赠送好友</div>
          <div class="icon-text text-tipcolor">{{phoneNum}}</div>
        </div>
        <!-- <div class="packageDesc_shangpin_box">
        <div class="packageDesc_shangpin_mesgname">套餐</div>
        <div class="packageDesc_taocanbox">
          <div v-for="(item,index)  in showItem.productItem" :key="index" :class="packageIndex===index ? 'packageDesc_shangpin_taocan' : 'packageDesc_shangpin_taocan1' "
            @click="changePackage(index)" id="changePackage" :data-index=" index ">{{item.name}}</div>
        </div>
      </div>
      <div class="packageDesc_shangpin_box" @click="toServiceList(showItem.id)" id="toServiceList" :data-service_id="showItem.id">
        <div class="packageDesc_shangpin_mesgname">适用网点</div>
        <div class="packageDesc_shangpin_shoujia">点击查看服务网点</div>
      </div> -->
        <div class="packageDesc_shangpin_box">
          <div class="text">可用时段</div>
          <div class="text" style="font-weight: bold;">周一至周日（法定节日除外）</div>
        </div>
      </div>
      <!-- 商品信息 结束 -->
      <div class="beCarefulbox">
        <div class="beCareful-titlebox">
          <div class="beCareful-icon"></div>
          <div class="beCareful-title">支付方式</div>
        </div>
        <div class="paybetten" v-if="showccardtype"  @click="changecard()">
          <div class="icontext-box">
            <img class="icon-icon" src="../../../static/vipicon.png" />
            <div class="icon-text">车主卡</div>
          </div>
          <div class="icontext-box">
            <div style="margin-right: 10px;" class="text text-tipcolor orderprice">-{{serviceList.discount_price}}</div>
            <img style="margin-right: 0;" class="icon-icon" :src="iscouponpay ? '../../../static/weixuancard.png' : (showcard ? '../../../static/checkdeicon.png' : '../../../static/weixuancard.png')" />
          </div>
        </div>
        <div class="paybetten" @click="showPopup()" >
          <div class="icontext-box">
            <img class="icon-icon" src="../../../static/kaquanpay.png" />
            <div class="icon-text">使用卡券</div>
          </div>
          <div class="icontext-box">
            <!-- <div style="margin-right: 10px;" class="text text-tipcolor orderprice">优惠券</div> -->
            <div style="margin-right: 10px;" class="text text-tipcolor orderprice">{{settlementItem.couponList ? settlementItem.couponList.length : 0}}
              张</div>
            <div style="margin-right: 10px;" class="text text-tipcolor orderprice" v-if="settlementItem.selectedID">已选</div>
            <div style="margin-right: 10px;" class="text text-tipcolor orderprice" v-else>未选</div>
            <img style="margin-right: 0;" class="icon-icon" :src="iscouponpay ? '../../../static/checkdeicon.png' : '../../../static/weixuancard.png'" />
<!--            <img style="margin-right: 0;" class="icon-icon" :src="!!settlementItem.selectedID ? '../../../static/checkdeicon.png' : '../../../static/weixuancard.png'" />-->

          </div>
        </div>
        <div class="paybetten" @click="weixinPay()">
          <div class="icontext-box">
            <img class="icon-icon" src="../../../static/weixinpay.png" />
            <div class="icon-text">微信支付</div>
          </div>
          <div class="icontext-box">
            <!-- {{showccardtype&&showcard ? serviceList.ccard_price : serviceList.price}} -->
            <div style="margin-right: 10px;" class="text text-tipcolor orderprice">￥{{ payAmount }}</div>
            <img style="margin-right: 0;" class="icon-icon" :src="isWeixinPay? '../../../static/checkdeicon.png' : '../../../static/weixuancard.png'" />
          </div>
        </div>
        <div class="betweenbox" @click="yuePay()">
          <div class="icontext-box">
            <img class="icon-icon" src="../../../static/jifenpay.png" />
            <div class="icon-text">可用积分({{amount}})</div>
          </div>
          <div class="icontext-box">
            <div style="margin-right: 10px;" class="text text-tipcolor orderprice">￥{{ payAmount }}</div>
            <img class="icon-icon" style="margin-right: 0;" :src="isamountpay ? '../../../static/checkdeicon.png' : '../../../static/weixuancard.png'" />
          </div>
        </div>
      </div>
      <!-- 注意事项 开始 -->
      <div class="packageDesc_shangpinmesg">
        <div class="beCareful-titlebox">
          <div class="beCareful-icon"></div>
          <div class="beCareful-title">注意事项</div>
        </div>
        <div class="icon-text">此商品为电子券，购买后可在“<span class="text-tipcolor">个人中心-卡券</span>”页面查询使用;</div>
        <div class="icon-text">洗车打蜡券使用说明：网点使用服务后出示券二维码，商家扫描即可;</div>
        <div class="icon-text">机油服务使用说明：机油服务所使用机油产品由“优越服务”官方提供，商家提供安装服务，使用服务前需提前预约；</div>
        <div class="icon-text">漆面修复使用说明：单独喷漆服务（珍珠漆除外），不含钣金及拆装费，网点使用服务后出示券二维码，商家扫描即可；</div>
        <div class="icon-text">服务券有效期为一年，逾期失效，购买后非特殊原因不能退款;</div>
        <div class="icon-text">优惠活动由“优越服务”平台策划，商家提供服务，部分套餐限量供应，售完即止。</div>
      </div>
      <!-- 注意事项 结束 -->
    </div>
    <div class="rechage-bottom">
      <div class="tellbox">
        <a class="tellbox" style="color: #000000;font-size: 15px;" :href="'tel:' + phoneNumber">
          <img class="tell-icon" src="../../../static/callkefu.png" />
          <!-- <div class="icon-text">联系客服</div> -->
        </a>
      </div>
      <div class="recharge-botton1" @click="toBuySend">赠送好友</div>
      <div class="recharge-botton" style="width: 153px;" @click="zhifu">立即购买</div>
    </div>
    <!-- 弹框 -->
    <van-dialog v-model="show" title="赠送好友" show-cancel-button :beforeClose="chargeBtn">
      <!--输入框-->
      <van-field v-model="phoneNum" rows="1" autosize type="number" placeholder="请输入手机号" style="text-align: center;font-size: 14px;" />
    </van-dialog>

    <!-- 卡券弹出层 开始 -->
    <van-popup v-model="showCardList" position="bottom" :style="{ height: '50%' }">
      <div class="cardlist_popup_top">
        <!--  @click="cancel()" -->
        <div class="cardlist_popup_topcancel"></div>
        <div class="cardlist_popup_topcenter">选择卡券</div>
        <!-- @click="confirm()" -->
        <div class="cardlist_popup_topconfirm"></div>
      </div>
      <div class="cardlist_popup_list">
        <div class="cardlist_popup_box1" v-for="(item,index) in settlementItem.couponList" @click="couponChange(index)">
          <div>
            <div class="cardlist_popup_boxtop">卡券名称：{{ item.name ? item.name : item.product.name }}</div>
            <div class="cardlist_popup_boxbot">到期日期：{{ item.overdue_at }}</div>
          </div>
          <img class="cardlist-pop-check" :src="item.checked ? '../../../static/checkdeicon.png' : '../../../static/weixuancard.png'" />

          <!-- <img class="cardlist_popup_img" src="/static/keyong.png" /> -->
        </div>
      </div>
    </van-popup>
    <!-- 卡券弹出层 结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
    import {
    Toast
  } from 'vant';
  const openLoading = () => {
    Toast.loading({
      message: "加载中",
      duration: 0, // toast不消失
    });
  }
  export default {
    data() {
      return {
        id: '', // 上一页获取套餐详情编号,默认为空
        showItem: {}, // 接口获取套餐详情,默认为空
        packageIndex: 0, // 上一页获取套餐详情的套餐列表的指针,默认为0
        userInfo: {}, //接口获取用户信息
        mobile: "",
        showCardList: false,
        store_id: "",
        serviceid: "",
        serviceList: {},
        amount: '0.00', // 可用余额
        settlementItem: {
          canAmountPay: false, // 前端计算可用余额是否大于服务价格,默认为false
          couponList: [], // 服务券列表,默认为空
          isAmountPay: false, // 用户是否使用余额结算,默认为false
          selectedID: "" // 用户选择服务券的编号,默认为空
        }, // 接口获取结算方式
        maskStatus: '', // 遮盖层所展示的状态类型
        isMaskHidden: true, // 是否隐藏遮盖层,默认为true
        buttonClicked: false, // 防止支付重复点击,默认为false
        order_param: {},
        phoneNum: "", //手机号
        show: false, //是否显示服务券列表弹出框
        preferentialAmount: 0, //满减券优惠金额
        payAmount: 0, //应付金额
        phoneNumber: "",
        product_id: "",
        showcard:true,
        iscouponpay:false,//卡券支付
        isamountpay:true,//积分支付
        isWeixinPay: false, //微信支付
        showccardtype:false
      }
    },
    created() {
      let that = this
      this.phoneNumber = sessionStorage.getItem("phoneNumber")
      //上一页面传过来的参数
      console.log("id", that.$route.query.id)
      if (that.$route.query.id) {
        that.id = Number(that.$route.query.id)
      } else {
        that.id = ""
      }
      // console.log("packageIndex", that.$route.query.index)
      if (that.$route.query.index) {
        that.packageIndex = Number(that.$route.query.index)
      } else {
        that.packageIndex = 0
      }

      if (this.$route.query.store_id) {
        this.store_id = this.$route.query.store_id
      } else {
        this.store_id = ""
      }
      if (this.$route.query.product_id) {
        this.product_id = this.$route.query.product_id
      } else {
        this.product_id = ""
      }
      if (this.$route.query.serviceid) {
        this.serviceid = this.$route.query.serviceid
      } else {
        this.serviceid = ""
      }
      this.request("getStoreservice", {
        product_id: this.product_id,
        store_id: this.store_id
      })
      //this.request("getUserInfo")
    },
    mounted() {
      if (!this.id) return
      let requestData = {
        id: this.id
      }
      //this.request('getPackageDetail', requestData)

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      changecard(){
        let that = this
        this.showcard=!this.showcard
        if(this.userInfo.ccard.status==1){
          this.showcard=false
          Dialog.confirm({
            title: '提示',
            message: '请先激活车主卡',
          })
            .then(() => {
              let card_id = that.userInfo.ccard.id
              that.$router.push({
                path:"/vipcard",
                query:{
                  ccard_id:card_id
                }
              })
            })
            .catch(() => {
              return false;
            });
        }else{
          if(this.showcard){
            this.iscouponpay=false
            this.settlementItem.selectedID=""
            let list = this.settlementItem.couponList
            for(let i in list){
              list[i].checked=false
            }
            this.settlementItem.couponList = list
          }
        }

      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true;
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === "number") {
            setTimeout(() => {
              this.buttonClicked = false;
            }, duration);
          }
          resolve(true);
        });
      },
      toBuySend() {
        //当点击按钮时，显示弹出框
        this.show = true;
      },
      //微信支付
      weixinPay() {
        this.isWeixinPay = true
        this.isamountpay = false
        // this.iscouponpay = false
        // this.settlementItem.selectedID=""
        // let list = this.settlementItem.couponList
        // for(let i in list){
        //   list[i].checked=false
        // }
        // this.settlementItem.couponList = list
        if(this.userInfo.ccard.status==1){
          this.showcard=false
          Dialog.confirm({
            title: '提示',
            message: '请先激活车主卡',
          }).then(() => {
            let card_id = that.userInfo.ccard.id
            that.$router.push({
              path:"/vipcard",
              query:{
                ccard_id:card_id
              }
            })
          }).catch(() => {
            return false;
          });
        }else{
          this.showcard=true
        }
      },
      //余额支付
      yuePay() {
        this.isamountpay = true
        this.isWeixinPay = false
        // this.iscouponpay = false
        // this.settlementItem.selectedID=""
        // let list = this.settlementItem.couponList
        // for(let i in list){
        //   list[i].checked=false
        // }
        // this.settlementItem.couponList = list
        if(this.userInfo.ccard.status==1){
          this.showcard=false
          Dialog.confirm({
            title: '提示',
            message: '请先激活车主卡',
          }).then(() => {
              let card_id = that.userInfo.ccard.id
              that.$router.push({
                path:"/vipcard",
                query:{
                  ccard_id:card_id
                }
              })
            }).catch(() => {
              return false;
            });
        }else{
          this.showcard=true
        }
      },
      //关闭弹出层
      guanbi() {
        this.showCardList = false
      },
      showPopup() {

        if (this.settlementItem.couponList.length == 0) {
          this.$toast({
            message: '暂无可用卡券',
          })
        } else {
          this.showCardList = true
        }

      },
      // 选择服务券
      couponChange(sel_index) {
        let that = this
        let settlementItem = that.settlementItem;
        let couponList = settlementItem.couponList;
        couponList.map(function(item, i) {
          if (i == Number(sel_index)) {
            if (item.checked == false) {
              item.checked = true
              that.settlementItem.selectedID = item.id;
              that.payAmount = item.coupon.amount
              // //满减券优惠金额
              // that.preferentialAmount = item.amount
              // //卡券金额
              // let originalPrice = parseFloat(that.preferentialAmount)
              // //商品价格
              // let price = parseFloat(that.serviceList.price)
              // //实付金额
              // that.payAmount = price > originalPrice ? (price - originalPrice).toFixed(2) : 0
            } else {
              item.checked = false;
              that.settlementItem.selectedID = ''
              //满减券优惠金额
              that.preferentialAmount = 0
              //实付金额
              that.payAmount = parseFloat(that.serviceList.price)
            }
          } else {
            item.checked = false;
          }
        })
        if(that.settlementItem.selectedID){
          this.iscouponpay = true
          this.showcard=false
          // this.isamountpay=false
          // this.isWeixinPay=false
        }
        that.settlementItem = settlementItem;
        that.guanbi();
      },

      chargeBtn(action, done) { //确认or取消
        if (action === 'cancel') { //取消按钮
          done();
        } else if (action === 'confirm') { //确定按钮
          //向后端传值并关闭dialog弹出框
          this.show = false;
          // let showItem = this.showItem
          if (!(/^1[3456789]\d{9}$/.test(Number(this.phoneNum)))) {
            this.$toast({
              message: '手机号格式错误'
            })
            done();
            return
          }
        }
        done();
      },
      // 点击触发
      // 切换商品的套餐
      changePackage(index) {
        this.showItem.productItem.map((item, index) => item.checked = index === Number(index))
        // this.showItem = this.showItem
        this.packageIndex = Number(index)
      },
      // 跳转到服务商家页面
      toServiceList(product_id) {
        this.$router.push({
          path: '/serviceList',
          query: {
            product_id: product_id
          }
        })
      },
      zhifu() {
        let that = this
        this.buttonClickedFun(1000) // 防止重复点击
        if ((!this.mobile)) {
          Dialog.confirm({
              title: '提示',
              message: '请先绑定手机',
            })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        }
        var order_param = this.order_param
        //order_param.amount = this.payAmount
        order_param.amount = this.serviceList.price
        order_param.type = 'offline'
        order_param.product_type = 1
        order_param.product_item_id = this.serviceList.id
        order_param.product_id = this.serviceList.product_id
        if (that.settlementItem.selectedID) {
          order_param.coupon_id = that.settlementItem.selectedID
        }
        if (this.phoneNum) {
          order_param.recharge_number = this.phoneNum
        }
        
        if(this.isWeixinPay){
          //微信购买
          if(this.userInfo.ccard.status==10 && this.showcard){
              Dialog.confirm({
                title: '提示',
                message: '是否用微信支付?',
              })
                .then(() => {
                  order_param.pay_type = 'wechatpay' //车主卡微信支付
                  if(this.userInfo.ccard.status==10 && this.showcard){
                    order_param.ccard_user_id = that.userInfo.ccard.id
                  }
                  openLoading()
                  that.request('WxunifiedOrder', order_param)
                })
                .catch(() => {
                  return false;
                });
          }
        }else{
            //余额支付
            if (parseFloat(that.amount) < parseFloat(this.payAmount)) {
              Dialog.confirm({
                title: '提示',
                message: '积分不足，前往充值？',
              })
                .then(() => {
                  that.$router.push({
                    path: "/account"
                  })
                })
                .catch(() => {
                  return false;
                });
            } else {
              Dialog.confirm({
                title: '提示',
                message: '是否用余额支付?',
              })
              .then(() => {
                  order_param.pay_type = 'balance' //余额支付
                  if(this.userInfo.ccard.status==10 && this.showcard){
                    order_param.ccard_user_id = that.userInfo.ccard.id
                  }
                  console.log("order_param",order_param);
                  openLoading()
                  that.request('YeunifiedOrder', order_param)
                })
                .catch(() => {
                  return false;
                });
            }
        }
      },

      // 带参跳转到订单支付页面
      toBuy() {
        // console.log((!this.mobile))
        let that = this
        if ((!this.mobile)) {
          // this.$toast({
          //   message: '请先绑定手机',
          // }).then((confirm) => {
          //   if (confirm) {
          //     this.$router.push({
          //       path: '/changePhoneNum'
          //       // url: '../welcome/welcome?phoneStatus=true'
          //     })
          //   } else {
          //     return false;
          //   }
          // })
          Dialog.confirm({
            title: '提示',
            message: '请先绑定手机',
          })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        }
        // let id = this.packageIndex
        // let item = this.showItem.productItem[id]
        // let originalPrice = item.m_price ? parseFloat(item.m_price).toFixed(2) : '0.00'
        // let price = item.price ? parseFloat(item.price).toFixed(2) : '0.00'
        // let thumb = this.showItem.thumb
        // let showItem = this.showItem
        // this.$router.push({
        //   path: '/buy',
        //   query: {
        //     showItem: showItem,
        //   }
        // })
      },
      tobuyDetail() {
        this.$router.push({
          path: '/buyDetail'
        })
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                console.log("用户信息", res.data)
                that.userInfo = res.data
                that.mobile = res.data.mobile
                that.amount = res.data.account.amount
                this.showcard = !(Object.keys(that.userInfo.ccard).length === 0);
                this.showccardtype = !(Object.keys(that.userInfo.ccard).length === 0);
              }
            }, true)
            break
            //  获取套餐详情
            // case 'getPackageDetail':
            //   httper.get('product/detail', requestData, res => {
            //     console.log('套餐详情', res)
            //     that.showItem = res.data
            //     res.data.productItem.map((item, index) => item.checked = index === that.packageIndex)
            //     that.showItem = res.data
            //   }, false)
            //   break
          case 'getPackageDetail':
            httper.get('/store/service-detail', requestData, res => {
              console.log('套餐详情', res)
              that.showItem = res.data
              // res.data.productItem.map((item, index) => item.checked = index === that.packageIndex)
              // that.showItem = res.data
            }, false)
            break
            // 获取店铺服务详情
          case "getStoreservice":
            httper.post("store/ser-detail", requestData, res => {
              if (res.code == 0) {
                that.serviceList = res.data;
                that.payAmount = parseFloat(that.serviceList.price)
                this.request("getUserInfo")
                this.request("getCouponList",{
                  pro_id:this.serviceList.product_id,
                  order_type:'offline'
                });
              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true);
            break;
            //余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/place-order', requestData, res => {
              console.log("支付");
              if (res.code === 0) {
                setTimeout(() => {
                  Toast.clear();
                }, 100)
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                setTimeout(() => {
                  Toast.clear();
                }, 100)
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //卡券列表
          case "getCouponList":
            httper.get("/coupon/usable-coupon-by-pro", requestData, res => {
              
              if (res.data) {
                let list = res.data;
                // console.log("res.data", res.data)
                // res.data.map(function(item, i) {
                //   if (item.product.type == that.serviceList.product.type && item.product.type == 2 && item.status ==
                //     0 && item.type == 3) {
                //     list.push(item)
                //   } else if (item.product_id == that.serviceList.product_id && item.status == 0 && item.type ==
                //     3) {
                //     list.push(item)
                //   } else if (item.product_id == that.serviceList.product_id && item.status == 0 && item.type ==
                //     1) {
                //     list.push(item)
                //   }
                // })

                if (list.length > 0) {
                  list.map(v => {
                    that.$set(v, 'checked', false)
                    return v
                  })
                }
                //   list[0].checked = true
                //   that.settlementItem.selectedID = list[0].id
                //   that.preferentialAmount = list[0].amount
                //   //卡券金额
                //   let originalPrice = parseFloat(that.preferentialAmount)
                //   //商品价格
                //   let price = parseFloat(that.serviceList.price)
                //   //实付金额
                //   that.payAmount = price > originalPrice ? (price - originalPrice).toFixed(2) : 0
                // } else {
                //   that.payAmount = parseFloat(that.serviceList.price)
                // }
                that.settlementItem.couponList = list;
                // if(that.settlementItem.selectedID){
                //   this.iscouponpay = true
                //   this.showcard=false
                //   this.isamountpay=false
                //   this.isWeixinPay=false
                // }
                // console.log("couponList", that.settlementItem.couponList)

              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true);

            break;
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/place-order', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                setTimeout(() => {
                  Toast.clear();
                }, 100)
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                setTimeout(() => {
                  Toast.clear();
                }, 100)
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
          case 'orderCancel':
            httper.post('/order/cancel', requestData, res => {
              console.log("取消", res)
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          that.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no

              that.$router.push({
                path: 'orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              that.$toast({
                message: '取消支付'
              })
              that.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              that.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style scoped>
  .packageDesc {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #F8F8FA;
  }

  .packageDesc_top {
    background-color: #ffffff;
    border-radius: 8px;
    width: 100%;
    height: 134px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .packageDesc_img {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
    border-radius: 25px;
  }

  .packageDesc_name {
    font-size: 19px;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }

  .packageDesc_shangpin_title {
    display: flex;
    align-items: center;
  }

  .packageDesc_shangpin_title_icon {
    width: 3px;
    height: 23px;
    margin-right: 10px;
  }

  .packageDesc_shangpin_title_name {
    font-size: 15px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
  }

  .packageDesc_shangpinmesg {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 20px;
    background-color: #ffffff;
    border-radius: 8px;
    margin-top: 10px;
  }

  .packageDesc_shangpin_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }

  .packageDesc_shangpin_mesgname {
    font-size: 11px;
    font-weight: 400;
    color: rgba(101, 101, 101, 1);
  }

  .packageDesc_shangpin_mesgvalue {
    text-decoration: line-through;
    color: rgba(187, 187, 187, 1);
  }

  .packageDesc_shangpin_shoujia {
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
  }

  .packageDesc_taocanbox {
    display: flex;
    justify-content: end;
    align-items: center;

  }

  .packageDesc_shangpin_taocan {
    width: 69px;
    height: 23px;
    background: #FD8C00;
    border: 1px solid #FD8C00;
    border-radius: 11px;
    font-size: 11px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .packageDesc_shangpin_taocan1 {
    width: 69px;
    height: 23px;
    border: 1px solid #FD8C00;
    border-radius: 11px;
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .packageDesc_shangpin_usetime {
    font-size: 11px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
  }

  .packageDesc_button {
    /* margin-top: 20px; */
    margin: 20px 30px 0;
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #fff;
  }

  .page_zhifu {
    width: 176px;
    height: 46px;
    background: linear-gradient(90deg, rgba(252, 183, 51, 1) 0%, rgba(242, 211, 86, 1) 100%);
    box-shadow: 0 4px 5px 2px rgba(242, 211, 86, 0.3);
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .page_zhifu1 {
    width: 176px;
    height: 46px;
    background: #FD8C00;
    box-shadow: 0 5px 7px 2px rgba(253, 140, 0, 0.3);
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input {
    border: none;
    font-size: 14px;
  }

  ::-webkit-input-placeholder {
    text-align: center;
    color: #BBBBBB;
    font-size: 12px;
  }

  .confim-box {
    width: calc(100% - 20px);
    border-radius: 8px;
    padding: 20px 0;
    box-sizing: border-box;
    margin: 10px 10px 100px;
  }

  /* 卡券弹出层 开始 */
  .cardlist_popup_top {
    width: 100%;
    height: 18%;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #EEEEEE;
  }

  .cardlist_popup_topcancel {
    font-size: 14px;
    color: #969799;
  }

  .cardlist_popup_topcenter {
    font-size: 16px;
  }

  .cardlist_popup_topconfirm {
    font-size: 14px;
    color: #576b95;
  }

  .cardlist_popup_list {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;

  }

  .cardlist_popup_box {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #EEEEEE;
    border-radius: 8px;
  }

  .cardlist_popup_box1 {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #FFFFFF;
    border: 1px solid #EA6E56;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cardlist_popup_boxtop {
    color: #363636;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .cardlist_popup_boxbot {
    color: #BBBBBB;
    font-size: 14px;
  }

  .cardlist-pop-check {
    width: 14px;
    height: 14px;
  }

  .cardlist_popup_img {
    position: absolute;
    top: 0;
    right: 0;
    width: 69px;
    height: 23px;
  }

  /* 卡券弹出层 结束 */
  .paybetten {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px dashed #BFBFBF;
    padding-bottom: 16px;
    margin-bottom: 10px;
  }

  .betweenbox {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .centerbox {
    display: flex;
    align-items: center;
  }

  .icontext-box {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .icon-icon {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }

  .icon-text {
    font-size: 14px;
  }

  .text {
    font-size: 15px;
  }

  .text-tipcolor {
    color: #FD8C00;
  }

  .beCarefulbox {
    width: 100%;
    padding: 10px 14px;
    box-sizing: border-box;
    color: #363636;
    font-size: 15px;
    background-color: #ffffff;
    border-radius: 8px;
  }

  .beCareful-titlebox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .beCareful-icon {
    width: 4px;
    height: 23px;
    background: #FD8C00;
    border-radius: 2px;
    margin-right: 10px;
  }

  .rechage-bottom {
    position: fixed;
    bottom: 0;
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
    width: 100%;
    left: 0;
  }

  .tellbox {
    width: 80px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .tell-icon {
    width: 40px;
    height: 40px;
  }

  .recharge-botton {
    width: 268px;
    height: 38px;
    background: #FD8C00;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: bold;
      color: #FFFFFF;
  }

  .recharge-botton1 {
    width: 153px;
    height: 38px;
    background: #E5E5E5;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    /* color: #F0CD01; */
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/offline/orderConfirm.vue